import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Select } from "antd";
import { Mading } from "@services/dtos/home.dto";
import { useQuery } from "@tanstack/react-query";
import { HomeService } from "@services/home.service";
import { FcFinePrint } from "react-icons/fc";
import { Spiner } from "@components/loaders/spiner";
import moment from "moment";
import { FilterOutlined } from "@ant-design/icons";
import { PopupCustom } from "@components/general/popup";
import { FilterButton } from "@components/general/filter_button";

export const MadingListPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<string>("10");
  const [popupFilter, setPopupFilter] = useState<boolean>(false);

  const kategori = "*";
  const { data: dataMading, isPending: isPendingMading } = useQuery({
    queryKey: [HomeService.queries.GET_MADING, kategori, limit],
    queryFn: () => HomeService.mading(kategori, limit),
  });

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Informasi Terkini",
      image: false,
    });
    setAppBar({
      title: "Informasi Terkini",
      show: true,
      leading: "back",
    });
  }, [setHeader, setAppBar]);

  const openDetailMading = (detailMading: Mading) => {
    navigate(linkPage.MADING_DETAIL, { state: detailMading });
  };

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        {/* set filter */}
        <div className="tw-pt-0 tw-text-background-100">
          <FilterButton
            limit={limit}
            text="data terakhir"
            onFilterClick={() => setPopupFilter(true)}
          />
        </div>
        {/* end of set filter */}

        {/* List */}
        <div className="tw-mt-8">
          {isPendingMading ? (
            <div className="tw-mt-4 card-body">
              <div className="tw-text-center">
                <Spiner />
              </div>
            </div>
          ) : dataMading?.data != null && dataMading.data.length > 0 ? (
            <>
              {dataMading.data.map((item, idx) => (
                <div key={idx} onClick={() => openDetailMading(item)}>
                  <div
                    className="tw-relative tw-p-4 tw-rounded-t-2xl tw-shadow-l tw-overflow-hidden tw-min-h-[150px]"
                    style={{
                      backgroundImage: `url(https://ponpes.darusunnahdlingo.com/assets/mading/${item.gambar})`,
                      backgroundSize: "cover",
                    }}
                  ></div>
                  <div className="tw-bg-background-100/30 tw-backdrop-blur-lg tw-rounded-b-2xl tw-p-2 tw-mb-6 tw-border tw-border-background-200/50">
                    <div className="tw-px-2 tw-text-[10px] tw-font-light tw-text-text-primary">
                      {moment(item.tanggal ?? Date.now()).format(
                        "dddd, DD MMMM YYYY"
                      )}
                    </div>
                    <div
                      className="tw-px-2 tw-mt-1 tw-text-md tw-font-medium tw-text-text-primary"
                      style={{
                        overflowWrap: "break-word",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.judul}
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="tw-mt-4 card-body">
              <div className="tw-p-8 tw-text-center">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            </div>
          )}
        </div>
        {/* end of List */}
      </div>

      <PopupCustom
        title="Filter Data"
        open={popupFilter}
        onCancel={() => setPopupFilter(false)}
        slideUpModal={true}
      >
        <div className="">
          <Select
            className=" tw-text-base"
            placeholder="Pilih Jumlah Ditampilkan"
            defaultValue={limit}
            style={{ width: "100%" }}
            allowClear
            onChange={(e) => setLimit(e)}
            options={[
              { value: "10", label: "10 data terakhir" },
              { value: "25", label: "25 data terakhir" },
              { value: "50", label: "50 data terakhir" },
              { value: "100", label: "100 data terakhir" },
            ]}
          ></Select>
          <Button
            onClick={() => setPopupFilter(false)}
            className="tw-p-2 tw-mt-6 tw-h-10 tw-w-full tw-text-base tw-rounded-xl tw-bg-red-500 tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
          >
            Tutup
          </Button>
        </div>
      </PopupCustom>
    </>
  );
};
